import { render } from "./RedialCall.vue?vue&type=template&id=7193c93e&scoped=true&ts=true&lang=pug"
import script from "./RedialCall.vue?vue&type=script&lang=ts"
export * from "./RedialCall.vue?vue&type=script&lang=ts"

import "./RedialCall.vue?vue&type=style&index=0&id=7193c93e&scoped=true&lang=css"

import exportComponent from "E:\\UiDesk\\laragon-5.0.0\\www\\click-to-call\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7193c93e"]])

export default __exports__